"use strict";

import "../scss/style.scss";

import VanillaPageReload from "./VanillaPageReload.js";
import IntersectionObserverScroll from "./IntersectionObserver.js";
import VanillaDropDown from "./VanillaDropDown.js";
import MicroModalWindow from "./MicroModalWindow.js";
import VanillaTitleDive from "./VanillaTitleDive.js";
import RellaxParallax from "./rellaxParallax.js";
import LenisSmoothScroll from "./LenisSmoothScroll.js";
import CultureFvScrollAnimation from "./CultureFvScrollAnimation.js";
import MwFormSwitcher from "./MwFormSwitcher.js";
import NewsFilter from "./NewsFilter.js";
import VanillaAccordion from "./VanillaAccordion.js";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    new VanillaPageReload();
    new IntersectionObserverScroll(".js-inview", "--inview-acv");
    new VanillaDropDown();
    new MicroModalWindow();
    new VanillaTitleDive("js-ttl", "js-ttl-char");
    new RellaxParallax(".js-rellax");
    new LenisSmoothScroll();
    new CultureFvScrollAnimation("#js-culture-lead", "#js-culture-fv-bg");
    new MwFormSwitcher();
    new NewsFilter();
    new VanillaAccordion(
      ".js-accordion-box",
      ".js-accordion-trigger",
      ".js-accordion-cnt",
    );
  },
  false,
);
